module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Light.638f24aa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GT-Walsheim-Light.ttf
// module id = 655
// module chunks = 0